import React from "react";
import CreatableSelect from "react-select/creatable";
import { useTagsField } from "./useTagsField";

interface TagsFieldProps {
  tagsField: ReturnType<typeof useTagsField>;
  label?: string;
  isDisabled?: boolean;
}

export const TagsField: React.FC<TagsFieldProps> = ({
  tagsField,
  label = "Tags",
  isDisabled = false,
}) => {
  const {
    tags,
    availableTags,
    isSearchingTags,
    onInputChange,
    onChange,
    isValidNewOption,
  } = tagsField;

  return (
    <div className="form-section mb-5">
      <h6 className="insert-tags-title pb-2 mb-2 border-bottom">{label}</h6>
      <CreatableSelect
        isMulti
        isDisabled={isDisabled}
        isLoading={isSearchingTags}
        options={availableTags}
        onInputChange={onInputChange}
        filterOption={() => true}
        value={tags.map((tag) => ({
          value: tag.entity_tag_id ?? tag.entity_tag_name,
          label: tag.entity_tag_name,
        }))}
        onChange={onChange}
        isValidNewOption={isValidNewOption}
        placeholder="Type to search tags..."
        classNamePrefix="react-select"
        styles={{
          control: (base: any) => ({
            ...base,
            borderRadius: "8px",
            borderColor: "#ced4da",
          }),
          multiValue: (base: any) => ({
            ...base,
            backgroundColor: "#824EEB",
            borderRadius: "4px",
          }),
          multiValueLabel: (base: any) => ({
            ...base,
            color: "#f0f0f0",
          }),
          multiValueRemove: (base: any) => ({
            ...base,
            color: "#f0f0f0",
            ":hover": {
              backgroundColor: "#6b3dc4",
              color: "white",
            },
          }),
        }}
      />
    </div>
  );
};

export default TagsField;
